<div class="flex flex-col gap-1">
  <h4 class="m-0 mb-3 text-xs font-semibold uppercase tracking-wide text-slate-400">
    {{ 'common.documents.audit.title' | translate }}
  </h4>
  @if (sortedEvents().length === 0) {
    <p class="text-xs text-slate-400">{{ 'common.documents.audit.empty' | translate }}</p>
  } @else {
    <div class="relative">
      <!-- Vertical line -->
      <div class="absolute left-[7px] top-2 bottom-2 w-px bg-slate-200"></div>

      <div class="flex flex-col gap-3">
        @for (event of sortedEvents(); track event.id) {
          <div class="flex gap-3">
            <div
              class="relative z-10 mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-slate-100 ring-2 ring-white"
            >
              <i class="pi text-[9px] text-slate-500" [class]="event.icon"></i>
            </div>
            <div class="min-w-0 flex-1">
              <p class="m-0 text-xs leading-relaxed text-slate-700">{{ event.text }}</p>
              <p class="m-0 text-[11px] text-slate-400">
                {{ event.createdAt | date: 'dd.MM.yyyy HH:mm' }}
              </p>
            </div>
          </div>
        }
      </div>
    </div>
  }
</div>
